import sosialisasi_keuangan from "../Dokumen/sosialisasi_keuangan.xls";
import surat_edaran from "../Dokumen/surat_edaran.pdf";
import tata_cara_pengadaan from "../Dokumen/tata_cara_pengadaan.pdf";
import AR_AV from "../Dokumen/AR_AV.pdf";
import standar_biaya_masukan from "../Dokumen/standar_biaya_masukan.pdf";
import materi_sosialisasi from "../Dokumen/materi_sosialisasi.pdf";
import pedoman_perjalanan from "../Dokumen/pedoman_perjalanan.pdf";
import kelengkapan_dokumen from "../Dokumen/kelengkapan_dokumen.pdf";
import tata_cara_pengadaan_2019 from "../Dokumen/tata_cara_pengadaan_2019.pdf";
import tata_cara_penatausahaan from "../Dokumen/tata_cara_penatausahaan.pdf";
import sosialisasi_integrasi from "../Dokumen/sosialisasi_integrasi.ppt";
import pengajuan_honor from "../Dokumen/pengajuan_honor.xls";
import nota_dinas from "../Dokumen/nota_dinas.pdf";
import sbm_ui from "../Dokumen/sbm_ui.pdf";
import tarif_sewa from "../Dokumen/tarif_sewa.pdf";
import sbm_2021 from "../Dokumen/sbm_2021.pdf";
import sbm_2022 from "../Dokumen/sbm_2022.pdf";
import sbm_2023 from "../Dokumen/sbm_2023.pdf";
import sbm_2024 from "../Dokumen/sbm_2024.pdf";
import penerapan_tarif_efektif from "../Dokumen/penerapan_tarif_efektif.pdf";
// import rps_morpho_syntax from "./Dokumen/rps_morpho_syntax.docx";
import slide_pmk from "../Dokumen/slide_pmk.pdf";

export const Documents = [
  {
    judul: "SBM UI th 2024",
    deskripsi: "SBM UI th 2024",
    dokumen: sbm_2024
  },
  {
    judul: "Slide PMK",
    deskripsi: "Slide PMK 66 2023 Natura Rev.2",
    dokumen: slide_pmk,
  },
  {
    judul: "Penerapan Tarif Efektif Rata-Rata",
    deskripsi:
      "Penerapan Tarif Efektif Rata-Rata (TER) Pada Pemotongan PPh Pasal 21",
    dokumen: penerapan_tarif_efektif,
  },
  {
    judul: "Pengajuan Manual 2020",
    deskripsi: "Pengajuan Keuangan sementara manual 2020",
    dokumen: sosialisasi_keuangan,
  },
  {
    judul: "SE Pengadaaan Barang dan Jasa",
    deskripsi: "Surat Edaran",
    dokumen: surat_edaran,
  },
  {
    judul: "SK Tata Cara Pengadaaan Barang dan Jasa",
    deskripsi: "Tata cara pengadaan barang dan jasa",
    dokumen: tata_cara_pengadaan,
  },
  {
    judul: "AR dan AV",
    deskripsi: "Authorized Vendor dan Authorized Vendor",
    dokumen: AR_AV,
  },
  {
    judul: "Standar Biaya Masukan UI Tahun 2019",
    deskripsi: "Peraturan Rektor UI Nomor 1 Tahun 2019",
    dokumen: standar_biaya_masukan,
  },
  {
    judul: "Materi Sosialisasi PPN",
    deskripsi: "Sosialisasi Sentaralisasi PPN dan Mekanisme Pengajuan e-Faktur",
    dokumen: materi_sosialisasi,
  },
  {
    judul: "Pedoman Perjalanan Dinas Dalam Negeri",
    deskripsi:
      "Peraturan Rektor Nomor 027 Tahun 2018 tentang pedoman perjalanan dinas UI",
    dokumen: pedoman_perjalanan,
  },
  {
    judul: "Kelengkapan Dokumen",
    deskripsi: "Materi Sosialisasi Kelengkapan Dokumen",
    dokumen: kelengkapan_dokumen,
  },
  {
    judul: "Tata Cara Pengadaan Barang dan Jasa",
    deskripsi: "Peraturan Rektor Universitas Indonesia Nomor 2 Tahun 2019	",
    dokumen: tata_cara_pengadaan_2019,
  },
  {
    judul: "Tata Cara Penatausahaan Piutang",
    deskripsi:
      "Peraturan Rektor UI Nomor 019 Tahun 2017 tentang Tata Cara Penata Usahaan Piutang UI",
    dokumen: tata_cara_penatausahaan,
  },
  {
    judul: "Sosialisasi Integrasi Keuangan Tahap 1",
    deskripsi: "Materi Sosialisasi Keuangan Tahap 1 tanggal 12 Maret 2019",
    dokumen: sosialisasi_integrasi,
  },
  {
    judul: "Pengajuan Honor",
    deskripsi: "Template Pengajuan Honor ke Bank",
    dokumen: pengajuan_honor,
  },
  {
    judul: "Nota Dinas PPN WR2",
    deskripsi: "Tata cara Pengenaan PPN",
    dokumen: nota_dinas,
  },
  {
    judul: "SBM UI Tahun 2020",
    deskripsi: "Standar Biaya Masukan UI Tahun 2020",
    dokumen: sbm_ui,
  },
  {
    judul: "Tarif Sewa Fasilkom",
    deskripsi: "Tarif sewa kelas, aula Fasilkom",
    dokumen: tarif_sewa,
  },
  {
    judul: "SBM 2021",
    deskripsi: "SBM 2021",
    dokumen: sbm_2021,
  },
  {
    judul: "SBM 2022",
    deskripsi: "SBM 2022	",
    dokumen: sbm_2022,
  },
  {
    judul: "SBM 2023",
    deskripsi: "PR 2023 NO 14 Tentang Standar Biaya Masukan Tahun 2023",
    dokumen: sbm_2023,
  },
];
